import { connect } from 'react-redux';

import MobileFilters from 'ha/components/Filters/MobileFilters';
import {
  getPriceFilterValues,
  getCategoriesFilter,
  getFurnitureFilter,
  getBillsFilter,
  getRoomsFilter,
  getSuitableForFilter,
  getRegistrationFilter,
  getRecentlyAddedFilter,
  getCountryCode,
  getSearchParams,
  getRulesFilter,
  getGenderFilter,
} from '../../selectors';
import {
  onChangeFilters,
  loadPreviewNumberOfListings,
  clearPreviewNumberOfListings,
} from '../../actions';

const mapStateToProps = state => ({
  typeFilter: getCategoriesFilter(state),
  furnitureFilter: getFurnitureFilter(state),
  billsFilter: getBillsFilter(state),
  suitableForFilter: getSuitableForFilter(state),
  roomsFilter: getRoomsFilter(state),
  priceFilter: getPriceFilterValues(state),
  registrationFilter: getRegistrationFilter(state),
  recentlyAddedFilter: getRecentlyAddedFilter(state),
  rulesFilter: getRulesFilter(state),
  genderFilter: getGenderFilter(state),
  countryCode: getCountryCode(state),
  searchParams: getSearchParams(state),
});

const mapDispatchToProps = {
  onSubmit: onChangeFilters,
  loadPreviewNumberOfListings,
  clearPreviewNumberOfListings,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MobileFilters);
